import React, { useState } from "react";
import BrandIdentity from "./BrandIdentity";
import { useBrand } from "../../context/BrandContext";
import { openApkDownload } from "../../utils/appUpdate";
import "./ForceUpdateScreen.css";

function ForceUpdateScreen({
  message,
  apkUrl,
  latestVersion,
  latestVersionCode,
  localVersion,
  localVersionCode,
  onRecheck,
}) {
  const [checking, setChecking] = useState(false);
  const brand = useBrand();
  const appName = brand.appName || brand.companyName || brand.shortName || "ESS HRMS";

  const handleUpdate = () => {
    openApkDownload(apkUrl);
  };

  const handleRecheck = async () => {
    if (typeof onRecheck !== "function") return;
    setChecking(true);
    try {
      await onRecheck();
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="force-update-screen" dir="rtl">
      <div className="force-update-content">
        <div className="force-update-brand">
          <div className="force-update-logo">
            <BrandIdentity
              showName={false}
              logoClassName="force-update-logo-img"
              fallbackClassName="force-update-logo-text"
            />
          </div>
          <p className="force-update-app-name" dir="ltr" lang="en">
            {appName}
          </p>
          <p className="force-update-slogan">
            {brand.slogan || "إدارة أذكى لفريقك"}
          </p>
        </div>

        <h2 className="force-update-title">تحديث مطلوب</h2>
        <p className="force-update-message">
          {message || "يتوفر تحديث جديد للتطبيق. يرجى التحديث للمتابعة."}
        </p>

        {(localVersion || latestVersion) && (
          <p className="force-update-versions">
            {localVersion
              ? `النسخة الحالية: ${localVersion}${localVersionCode ? ` (${localVersionCode})` : ""}`
              : null}
            {localVersion && latestVersion ? " — " : null}
            {latestVersion
              ? `آخر نسخة: ${latestVersion}${latestVersionCode ? ` (${latestVersionCode})` : ""}`
              : null}
          </p>
        )}

        <button
          type="button"
          className="force-update-primary-btn"
          onClick={handleUpdate}
          disabled={!apkUrl}
        >
          تحديث الآن
        </button>

        {typeof onRecheck === "function" && (
          <button
            type="button"
            className="force-update-secondary-btn"
            onClick={handleRecheck}
            disabled={checking}
          >
            {checking ? (
              <span className="force-update-spinner" />
            ) : (
              "إعادة التحقق"
            )}
          </button>
        )}
      </div>
    </div>
  );
}

export default ForceUpdateScreen;
